import React, {useContext, useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {MapContext} from '../../services/map-v2/map.context';
import './no-parking-legend.scss';
import '../../components/buttons/switch-button/switch-button.scss';

export const NoParkingLegend = () => {
    const {
        isNoParkingActive,
        activateNoParkingLayer,
        deactivateNoParkingLayer,
        noParkingActive,
        setNoParkingActive,
        transportListActivatedOnce,
    } = useContext(MapContext);

    const {t} = useTranslation();
    const [isSwitchActive, setIsSwitchActive] = useState(isNoParkingActive);

    useEffect(() => {
        if (transportListActivatedOnce && !noParkingActive) {
            setIsSwitchActive(true);
            activateNoParkingLayer();
            setNoParkingActive(true);
        }
    }, [transportListActivatedOnce, noParkingActive, activateNoParkingLayer, setNoParkingActive]);

    const toggleLayer = () => {
        const newState = !isSwitchActive;
        setIsSwitchActive(newState);

        if (newState) {
            activateNoParkingLayer();
        } else {
            deactivateNoParkingLayer();
        }
    };

    return (
        <div className="no-parking-legend">
            <div className="transports-item-info">
                <div className="circle"></div>
                <span className="text">{t('translation:no_parking_legend')}</span>
            </div>
            <div className="switch-button">
                <span
                    role="button"
                    onClick={toggleLayer}
                    onKeyDown={toggleLayer}
                    tabIndex={0}
                    aria-pressed={isSwitchActive}
                    className={isSwitchActive ? 'switch-label active' : 'switch-label'}
                >
                    <span className={isSwitchActive ? 'switch-button active' : 'switch-button'} />
                </span>

            </div>
        </div>
    );
};
